var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.splitScreenDialogVisible,
        callback: function ($$v) {
          _vm.splitScreenDialogVisible = $$v
        },
        expression: "splitScreenDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.tsg("selectSplitScreenLayout")) + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.splitScreenDialogVisible = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { justify: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0 pt-5 pb-9",
                                    attrs: {
                                      align: "center",
                                      justify: "center",
                                    },
                                  },
                                  [
                                    _vm.viewCount !== 4
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "4" },
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { justify: "center" },
                                              },
                                              [
                                                _c("v-img", {
                                                  staticClass: "ma-0 pa-0 mb-4",
                                                  attrs: {
                                                    id: "split_image",
                                                    src: require("@/assets/images/4view.png"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { justify: "center" },
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-0 pl-2 pr-2",
                                                    attrs: {
                                                      width: "8rem",
                                                      id: "blue_btn",
                                                      elevation: "0",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setViewCount(
                                                          4
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          "4" +
                                                            _vm.tsg(
                                                              "createdLayoutWithCameras"
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.viewCount !== 9
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "4" },
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { justify: "center" },
                                              },
                                              [
                                                _c("v-img", {
                                                  staticClass: "ma-0 pa-0 mb-4",
                                                  attrs: {
                                                    id: "split_image",
                                                    src: require("@/assets/images/9view.png"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { justify: "center" },
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-0 pl-2 pr-2",
                                                    attrs: {
                                                      width: "8rem",
                                                      id: "blue_btn",
                                                      elevation: "0",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setViewCount(
                                                          9
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          "9" +
                                                            _vm.tsg(
                                                              "createdLayoutWithCameras"
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.viewCount !== 16
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "4" },
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { justify: "center" },
                                              },
                                              [
                                                _c("v-img", {
                                                  staticClass: "ma-0 pa-0 mb-4",
                                                  attrs: {
                                                    id: "split_image",
                                                    src: require("@/assets/images/16view.png"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { justify: "center" },
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-0 pl-2 pr-2",
                                                    attrs: {
                                                      width: "8rem",
                                                      id: "blue_btn",
                                                      elevation: "0",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setViewCount(
                                                          16
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          "16" +
                                                            _vm.tsg(
                                                              "createdLayoutWithCameras"
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }